import { render, staticRenderFns } from "./programCategories.vue?vue&type=template&id=555f1b52&"
import script from "./programCategories.vue?vue&type=script&lang=js&"
export * from "./programCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports